import axios from 'axios';

axios.interceptors.request.use(config => {
    if (typeof window === 'undefined') {
        return config;
    }

    const token = window.localStorage.getItem('token');

    if (token) {
        config.headers.Authorization = `bearer ${token}`;
    }

    return config;
});

const filesService = {
    submitFiles(data) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            let file = data.file;
            let file_name_array = file.name.split('.');
            formData.append('nomeArquivo', file.name);
            formData.append('extensaoArquivo', file_name_array[file_name_array.length - 1]);
            formData.append('conteudoArquivo', file);
            formData.append('solicitacaoID', data.solicitacaoID);
            formData.append('descricaoArquivo', data.descricaoArquivo);
            formData.append('ciUsuario', data.ciUsuario)
            axios.post('api/arquivo',
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    getFiles(id) {
        return new Promise((resolve, reject) => {
            axios.get('/api/arquivo/listar/' + id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    deleteFile(requestId, id, usuario) {
        return new Promise((resolve, reject) => {
            axios.get('/api/arquivo/excluir/' + requestId + '/' + id + '/' + usuario)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    downloadFile(id) {
        return new Promise((resolve, reject) => {
            axios.get('/api/arquivo/download/' + id)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    }
};

export default filesService;